//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Builder.js";
import "../Display/Display.LayerSettingsBuilder.js";
import "../no/LineColorFontWidthBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/TextColorFontWidthBuilder.js";
import "../no/Expression.js";
import "../no/Display.js";
import "../no/Expression.js";
import "../no/LineColorFontWidthBuilder.js";
import "../no/TextColorFontWidthBuilder.js";
import "../no/SelectObjectList.js";
let d=[[[0,"DrawingPlaneOption",1,0],[0,"InputText",1,0],[1,"LayerSettings",0,"Display.LayerSettingsBuilder",0],[0,"LevelOfOutline",1,0],[1,"LineColorFontWidth",0,"LineColorFontWidthBuilder",0],[0,"ReferenceSetToggle",1,0],[0,"ScopeOfOutline",1,0],[1,"SelectObject",0,"SelectDisplayableObjectList",0],[0,"SpecifyPlane",1,"Plane",0],[1,"TextColorFontWidth",0,"TextColorFontWidthBuilder",0],[1,"TextHeight",0,"Expression",0],[0,"TextLocation",1,"Point",0]],[[["nSelectedReferenceSet"],"GetSelectedReferenceSet",{R_:{selectedReferenceSet:""}},0,0],[["selectedReferenceSet"],"SetSelectedReferenceSet",{},1,0]],[]];
SPLM.LineDesigner.EnhancedShadowOutLineBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.EnhancedShadowOutLineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LineDesigner.EnhancedShadowOutLineBuilder.OutLineScope = Object.freeze({
    "CompleteComponent" : "CompleteComponent", "Objects" : "Objects"});

SPLM.LineDesigner.EnhancedShadowOutLineBuilder.OutLineLevel = Object.freeze({
    "Simple" : "Simple", "Detailed" : "Detailed"});

SPLM.LineDesigner.EnhancedShadowOutLineBuilder.DrawingPlaneOptions = Object.freeze({
    "Xcyc" : "Xcyc", "Yczc" : "Yczc", "Zcxc" : "Zcxc", "Custom" : "Custom"});

export default SPLM;